import { render, staticRenderFns } from "./RevShareContentDetailsModal.vue?vue&type=template&id=8630e1ca&scoped=true&"
import script from "./RevShareContentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./RevShareContentDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8630e1ca",
  null
  
)

export default component.exports